import * as Common from '@/tenant/common';

export class SalesJournalReportQuery extends Common.ReportQuery {
    constructor(){
        super("SalesJournalReportQuery", null);
    }
    public segment: Common.Segment = null;
    public counterpart: Common.Counterpart = null;
    public counterpartCategory: Common.Category = null;
    public commodity: Common.Commodity = null;
    public commodityCategory: Common.Category = null;
    public deliveryDateFrom: Date = null;
    public deliveryDateTo: Date = null;
    public bookDateFrom: Date = new Date().getCalendarDate();
    public bookDateTo: Date = new Date().getCalendarDate();
    public onExcelExport:boolean = false;               
}

export class SalesJournalReportTemplateQuery extends Common.ReportTemplateQuery {
  queryName ='SalesJournalReportQuery';
  sort = 'id';
  constructor() {
    super();
  }
}
